var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMexcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.928 97.0176 498.1448 305.9654",
    width: 498.1448,
    height: 305.9654,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5575_77706",
    x1: 9.98992,
    y1: 15.8576,
    x2: 22.8421,
    y2: 20.6068,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(20.372498, 0, 0, 20.372498, -67.767928, -65.959896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#264CA1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#234588"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M 491.043 313.098 L 383.333 126.242 C 359.702 87.29 302.129 86.882 279.332 127.892 L 166.223 322.205 C 145.097 357.837 171.194 402.575 213.468 402.575 L 440.091 402.575 C 482.751 402.575 514.655 356.593 491.043 313.098 Z",
    fill: "#3156AA",
    style: {},
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 3.552713678800501e-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 335.682 327.603 L 329.061 315.991 C 322.848 305.214 309.178 282.031 309.178 282.031 L 218.03 123.757 C 194.42 88.533 138.476 85.64 114.866 129.969 L 8.805 313.506 C -13.156 352.031 12.941 402.167 60.593 402.575 L 285.975 402.575 L 382.092 402.575 L 439.256 402.575 C 380.848 403.003 362.208 372.75 335.682 327.603 Z",
    fill: "#1972E2",
    style: {},
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 3.552713678800501e-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 335.703 327.584 L 329.061 315.972 C 322.848 305.214 309.178 282.011 309.178 282.011 L 250.343 178.436 L 165.838 322.614 C 144.71 358.244 170.807 402.983 213.061 402.983 L 285.566 402.983 L 381.683 402.983 L 439.277 402.983 C 380.442 402.575 362.208 372.75 335.703 327.584 Z",
    fill: "url(#paint0_linear_5575_77706)",
    style: {},
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 3.552713678800501e-15)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexcLogo);
export default __webpack_public_path__ + "static/media/MEXCLogo.300284a6dfb867af7d61319569ede730.svg";
export { ForwardRef as ReactComponent };